import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Classes, Events } from './constants';
import { fixMobileHover, sortAnimations, initGTM, setCookiesAllowed, setDisclaimerAccepted, smoothScrollTo, disableBodyScroll, enableBodyScroll, getCookiesAllowed, wait } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- Fix Mobile Hover ----------

$Elements.window.on('load', () => fixMobileHover());

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, async() => {

	// ---------- Fix VH ----------

	$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
	$Elements.window.trigger('resize');

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.clearMatchMedia();
	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.body.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.body.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			smoothScrollTo(target);
		}
	});

	$Elements.body.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	// ---------- GLightbox ----------

	$('[target="lightbox"]').each(function() {

		let lightbox;

		if($(this).attr('data-size') === 'full') {

			lightbox = GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			lightbox = GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}

		lightbox.on('open', () => disableBodyScroll());
		lightbox.on('close', () => enableBodyScroll());
	});

	$('[target^="lightbox-gallery"]').each(function() {

		let lightbox;

		if($(this).attr('data-size') === 'full') {

			lightbox = GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			lightbox = GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"][target="lightbox"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}

		lightbox.on('open', () => disableBodyScroll());
		lightbox.on('close', () => enableBodyScroll());
	});

	// ---------- Disclaimer ----------

	$('#disclaimer').on('close.bs.alert', function() {
		setDisclaimerAccepted();
		$Elements.body.removeClass('disclaimer-open');
	});

	// ---------- Cookies ----------

	initGTM();

	if(!getCookiesAllowed()) {

		const cookies = document.querySelector('#cookies-allowed');

		if(cookies) {

			cookies.classList.remove(Classes.hidden);
			await wait(100);
			cookies.classList.add(Classes.show);

			$(cookies).on('click', '[data-bs-dismiss="alert"]', function() {
				setCookiesAllowed(this.dataset.allowed);
			});
		}
	}

});
